angular.module('impactx.beco').controller('BecoCancelListCtrl', BecoCancelListCtrl);

function BecoCancelListCtrl() {
    this.meta = {
        rowTemplate: 'modules/beco/templates/beco.row.html',
        isSelectAble: false,
        endpoint: '/beco/cancel',
        ctrl: this,
        id: "becocancellist",
        excelExport: true
    };
    this.getMeta = function () {
        return this.meta;
    };
}